export default __webpack_public_path__ + "static/not_found@2x-acf0c6fceeb1c3ff1f54df1da029719a.png";